import { render, staticRenderFns } from "./WidgetBookingResume.vue?vue&type=template&id=2f405e7f&scoped=true"
import script from "./WidgetBookingResume.vue?vue&type=script&lang=js"
export * from "./WidgetBookingResume.vue?vue&type=script&lang=js"
import style0 from "./WidgetBookingResume.vue?vue&type=style&index=0&id=2f405e7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f405e7f",
  null
  
)

export default component.exports